import { useState } from 'react';

interface QuantityInputProps {
    value: number | string;
    onFocus: () => void;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}

/**
 * Input de quantidade controlado pela store.
 *
 * Enquanto o usuário digita, exibe o texto local; ao sair do campo, envia o
 * valor (`onCommit`) e volta a exibir a quantidade da store. Assim, quando a
 * store ajusta o valor (mínimo/máximo, recálculo de campanha) para o mesmo
 * número que já estava salvo, o campo não fica preso no valor digitado.
 */
export const useQuantityInput = (
    quantity: number,
    onCommit: (value: number) => void,
): QuantityInputProps => {
    const [draft, setDraft] = useState<string | null>(null);

    return {
        value: draft ?? quantity,
        onFocus: () => setDraft(quantity === 0 ? '' : `${quantity}`),
        onChange: (e) => setDraft(e.target.value),
        onBlur: (e) => {
            setDraft(null);
            const value = Number(e.target.value);
            if (value < 0) return;
            onCommit(value || 0);
        },
    };
};
